/** @format */

import styled from 'styled-components';

export const Outer = styled.div`
  background-color: ${({ theme }) => theme.colors.joivy['teal-dark']};
  bottom: 0;
  color: ${({ theme }) => theme.colors.joivy.white};
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  left: 0;
  padding: 60px 16px;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 4;
`;

export const Menu = styled.ul`
  margin: 0;
  padding: 0;
  list-style-type: none;

  a {
    text-decoration: none;
    color: ${({ theme }) => theme.colors.joivy.white};
  }
`;

export const ButtonClose = styled.button`
  font-size: 1.375rem;
  color: ${({ theme }) => theme.colors.joivy.white};
  cursor: pointer;
  background: transparent;
  border: none;
`;

export const ButtonOpen = styled.button`
  background: none;
  border: none;
  background: transparent;
  border: none;

  @media screen and (min-width: 1476px) {
    display: none;
  }
`;

export const Footer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;
